module.exports = __webpack_public_path__ + "img/qr4.cea174da.png";